import moment from 'moment';
import { Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBellSlash, faUserTag } from '@fortawesome/free-solid-svg-icons';
import hasPermission from '../../../../Shared/hasPermission';
import { shallowEqual, useSelector } from 'react-redux';

const AssignmentAndMute = () => {
    const {
        assignedAccountId,
        assignedAccountName,
        muteMessage,
        muteUntil,
        muteReasonName,
    } = useSelector((state) => {
        const {
            assignedAccountId,
            assignedAccountName,
            muteMessage,
            practiceMute,
        } = state.practice.practice;
        const { muteUntil = 0, muteReasonName = '' } = practiceMute ?? {};
        return {
            assignedAccountId,
            assignedAccountName,
            muteMessage,
            muteUntil,
            muteReasonName,
        };
    }, shallowEqual);
    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canAssign = hasPermission(`Assignment`, permissions);

    return (
        <>
            {canAssign && assignedAccountId && (
                <Col
                    md={12}
                    className="hide-overflow d-flex px-3 py-2"
                    title="Assigned User">
                    <FontAwesomeIcon
                        className="text-light op-6"
                        icon={faUserTag}
                        size="lg"
                    />
                    &emsp;{assignedAccountName}
                </Col>
            )}
            {moment.unix(muteUntil) > moment() && (
                <Col
                    md={12}
                    className={'hide-overflow d-flex px-3 py-2'}
                    title={`Practice is Muted until ${moment
                        .unix(muteUntil)
                        .format('MMM D, YYYY h:mm a')}`}>
                    <FontAwesomeIcon
                        className="text-light op-6"
                        icon={faBellSlash}
                        size="lg"
                    />
                    &emsp;
                    {moment.unix(muteUntil).format('MMM D, YYYY h:mm a')}
                    {muteReasonName && (
                        <span className="text-wrap">
                            &nbsp;{`- ${muteReasonName}`}
                        </span>
                    )}
                </Col>
            )}
            {/* This looks like this works but muteMessage isn't being passed down. Removing for not ibn favor od displaying MuteReason/*}
            {/* {!!muteMessage && (
                <Col md={12} className="pl-5 hide-overflow p-2 pr-3 text-wrap">
                    {muteMessage}
                </Col>
            )} */}
        </>
    );
};

export default AssignmentAndMute;
